import { config } from "../constants";
import { authHeader } from "../helpers";
import { handleResponse } from "./handle-response";

export const uploadPdf = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: data,
  };

  return fetch(`${config.API_URL}/admin/mom-doc/`, requestOptions).then(
    handleResponse,
  );
};

export const downloadPdf = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(
    `${config.API_URL}/admin/mom-doc/download/`,
    requestOptions,
  ).then(handleResponse);
};

export const getMOMListData = (params = {}) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  // Build query parameters for pagination using limit/offset
  const queryParams = new URLSearchParams();
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.offset !== undefined) queryParams.append('offset', params.offset);
  if (params.quarter_id) {
    queryParams.append('quarter_id', params.quarter_id);
  }


  const queryString = queryParams.toString();
  const url = `${config.API_URL}/admin/mom-doc/${queryString ? `?${queryString}` : ''}`;

  return fetch(url, requestOptions).then(handleResponse);
};
